import { FC } from 'react';
import ReactModal from 'react-modal';
import { IModalBase } from '../../types';
import styles from './styles.module.css';

const ModalBase: FC<IModalBase> = (props) => {

  const {
    isOpen,
    onClose,
    timeout = 350,
    style,
    contentLabel = 'Modal',
    closeOnOverlayClick = true,
    closeOnEsc = true,
    children,
    ...rest
  } = props;

  const styleExtended = {
    overlay: {
      ...(style && style.overlay && { ...style.overlay }),
    },
    content: {
      ...(style && style.content && { ...style.content }),
    },
  };

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      closeTimeoutMS={timeout}
      contentLabel={contentLabel}
      style={styleExtended}
      overlayClassName={{
        base: styles.overlay,
        afterOpen: styles.overlayAfterOpen,
        beforeClose: styles.overlayBeforeClose,
      }}
      className={{
        base: styles.container,
        afterOpen: styles.containerAfterOpen,
        beforeClose: styles.containerBeforeClose,
      }}
      shouldCloseOnOverlayClick={closeOnOverlayClick}
      shouldCloseOnEsc={closeOnEsc}
      {...rest}
    >
      {children}
    </ReactModal>
  );

};

export default ModalBase;
